import { NgModule } from '@angular/core';
import { IconModule } from '../../common';
import { SocialLinkComponent } from './social-link.component';

@NgModule({
  declarations: [SocialLinkComponent],
  exports: [SocialLinkComponent],
  imports: [IconModule],
})
export class SocialLinkModule {}
